import last from "lodash/last";
import { getFileIconFromName } from "logic/src/objects/file/utils";
import { ReactComponent as DeleteIcon } from "logic/src/components/icons/delete.svg";
import styles from "./index.module.scss";

interface IProps {
  name: string;
  onDelete?: () => void;
  onNameClick: () => void;
}

const FileWidget: React.FC<IProps> = ({ name, onDelete, onNameClick }) => {
  const Icon = getFileIconFromName(name);
  // // 为防止文件名中有"."但不是扩展名的情况,把"."后面字符串短于7个字符的情况当做扩展名处理
  const extension =
    name.lastIndexOf(".") > 0 && last(name.split("."))!.length < 7
      ? last(name.split("."))
      : "";
  const realFileName = extension
    ? name.slice(0, Number("-" + (extension.length + 1)))
    : name;

  const displayFileName =
    realFileName.length > 14 ? realFileName.slice(0, 13) + "..." : realFileName;

  return (
    <div className={styles.container}>
      <div className={styles.textWrap} onClick={onNameClick}>
        <Icon className={styles.fileIcon} />
        <span>{realFileName}</span>
        <span className={styles.ext}>{!!extension ? `.${extension}` : ""}</span>
      </div>
      {onDelete && (
        <DeleteIcon className={styles.deleteIcon} onClick={onDelete} />
      )}
    </div>
  );
};

export default FileWidget;
